<template>
    <div
        v-if="shouldShow"
        class="upload-document-page"
    >
        <div v-if="isSent"><PendingStatus /></div>
        <template v-else>
            <SectionHeader :icon="`icon-upload_2`">
                {{ $capitalize($t('upload a document photo').toString()) }}
            </SectionHeader>
            <DocumentUploadForm
                @success="onSuccess"
                @error="onError"
                :documentOnly="true"
                :fileSize="config.documentUpload.fileSize"
                :fileSizeHumanReadable="config.documentUpload.fileSizeHumanReadable"
                class="document-upload--in-page"
            />
        </template>
    </div>
</template>

<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    import { RouteName } from '@app/router/constants/RouteName';
    import DocumentUploadForm from '@modules/userProfile/documentUpload/components/DocumentUploadForm';
    import PendingStatus from '@modules/userProfile/idCardVerification/components/PendingStatus';
    import { openRequirements } from '@shared/userProfile/idCardVerification/IdCardVerificationRequired';
    import {
        sendVerifyIdentityEvent,
        AnalyticsKycEvent,
    } from '@accountFederation/modules/idCardVerification/analytics/idVerificationAnalytics';
    import { getIdVerificationStoreGetters } from '@accountFederation/modules/idCardVerification/analytics/idVerificationStoreGetters';
    import { verifyIdentityEntrypoints } from '@accountFederation/modules/idCardVerification/types';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

    export default {
        name: 'AccountContainer',
        data() {
            return {
                isSent: false,
                asyncErrors: {},
            };
        },
        created() {
            if (!this.shouldShow) {
                openRequirements(
                    {
                        redirect: RouteName.Account.Profile,
                    },
                    modalCodes.idCardVerificationIntro,
                    null,
                );
            }

            sendVerifyIdentityEvent({
                eventName: AnalyticsKycEvent.VerifyIdentityEntry,
                source: verifyIdentityEntrypoints.Upload,
                idVerificationStoreGetters: getIdVerificationStoreGetters(),
            });
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('data/country', [
                'config',
            ]),
            ...mapGetters('ui/multiStepVerification', [
                'isMultiStepIdVerification',
            ]),
            shouldShow() {
                const isNewKycDesign = this.isMultiStepIdVerification;
                return !isNewKycDesign && this.user.isVerifiedIdCard;
            },
        },
        methods: {
            ...mapActions('errors', [
                'showError',
            ]),
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            onSuccess() {
                this.isSent = true;
            },
            onError(e) {
                this.showError(e);
            },
        },
        components: {
            PendingStatus,
            DocumentUploadForm,
        },
    };
</script>
